import gql from 'graphql-tag';

export const CREATE_PACKAGE = gql`
  mutation CreateSubscriptionPackages(
    $input: CreateSubscriptionPackagesInput!
  ) {
    createSubscriptionPackages(input: $input) {
      _id
    }
  }
`;

export const UPDATE_PACKAGE = gql`
  mutation UpdateSubscriptionPackage(
    $input: UpdateSubscriptionPackagesInput!
    $updateSubscriptionPackageId: MOID!
  ) {
    updateSubscriptionPackage(input: $input, id: $updateSubscriptionPackageId) {
      _id
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation RemoveSubscriptionPackage($removeSubscriptionPackageId: MOID!) {
    removeSubscriptionPackage(id: $removeSubscriptionPackageId)
  }
`;
